import React from 'react';
import { Code, Zap, Target } from 'lucide-react';

const About = () => {
  return (
    <section className="about-section">
      <div className="section-container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title-large">Sobre Nosotros</h2>
            <p className="about-description">
              <strong>LTechSolutions</strong> es una agencia digital enfocada en ayudar a negocios 
              a mejorar su presencia online con páginas web modernas, rápidas y optimizadas.
            </p>
            <p className="about-description">
              Entendemos que cada negocio es único, por eso creamos soluciones personalizadas 
              que reflejan la identidad de tu marca y conectan con tus clientes.
            </p>
          </div>

          <div className="about-values">
            <div className="value-card">
              <div className="value-icon-wrapper">
                <Code size={36} />
              </div>
              <h3 className="value-title">Diseño Moderno</h3>
              <p className="value-description">
                Utilizamos las últimas tendencias en diseño web para crear experiencias atractivas
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon-wrapper">
                <Zap size={36} />
              </div>
              <h3 className="value-title">Tecnología Actual</h3>
              <p className="value-description">
                Desarrollamos con tecnologías modernas que garantizan velocidad y rendimiento
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon-wrapper">
                <Target size={36} />
              </div>
              <h3 className="value-title">Enfoque en Resultados</h3>
              <p className="value-description">
                Nuestro objetivo es que tu web te ayude a atraer más clientes y crecer
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
